
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kGADV", function(module, exports) {

$parcel$export(module.exports, "createPayloads", () => $1ce9cf3f9c71f474$export$51b606e6d67c2231);
$parcel$export(module.exports, "createExperimentalMetricsPayload", () => $1ce9cf3f9c71f474$export$6410c9ddb2ab201);

var $cDast = parcelRequire("cDast");

var $dh538 = parcelRequire("dh538");

var $baiQV = parcelRequire("baiQV");

var $bKXRh = parcelRequire("bKXRh");

var $33a21 = parcelRequire("33a21");

var $1haRI = parcelRequire("1haRI");

var $53d5Q = parcelRequire("53d5Q");

var $aqLdL = parcelRequire("aqLdL");

var $hhnFy = parcelRequire("hhnFy");

var $5QpZa = parcelRequire("5QpZa");

var $jJ2Ec = parcelRequire("jJ2Ec");

var $5i8ML = parcelRequire("5i8ML");

var $4u5NT = parcelRequire("4u5NT");

var $i328h = parcelRequire("i328h");

var $cSrwI = parcelRequire("cSrwI");

var $hS38r = parcelRequire("hS38r");

var $8litl = parcelRequire("8litl");

var $hPcrh = parcelRequire("hPcrh");

var $3AFGg = parcelRequire("3AFGg");

var $gY4WW = parcelRequire("gY4WW");

var $3uEtK = parcelRequire("3uEtK");

var $6Zbgf = parcelRequire("6Zbgf");

var $657nk = parcelRequire("657nk");

var $gffgQ = parcelRequire("gffgQ");
function $1ce9cf3f9c71f474$var$getUfoNameOverride(interaction) {
    const { ufoName: ufoName, apdex: apdex } = interaction;
    try {
        const ufoNameOverrides = (0, $53d5Q.getUfoNameOverrides)();
        if (ufoNameOverrides != null) {
            const metricKey = apdex.length > 0 ? apdex[0].key : '';
            if (ufoNameOverrides[ufoName][metricKey]) return ufoNameOverrides[ufoName][metricKey];
        }
        return ufoName;
    } catch (e) {
        return ufoName;
    }
}
function $1ce9cf3f9c71f474$var$getEarliestLegacyStopTime(interaction, labelStack) {
    let earliestLegacyStopTime = null;
    interaction.apdex.forEach((a)=>{
        if (!a?.stopTime) return;
        if (!(0, $3AFGg.labelStackStartWith)(a.labelStack ?? [], labelStack)) return;
        if (a.stopTime > interaction.start && (earliestLegacyStopTime ?? a.stopTime) >= a.stopTime) earliestLegacyStopTime = a.stopTime;
    });
    return earliestLegacyStopTime;
}
function $1ce9cf3f9c71f474$var$getBm3EndTimeOrFallbackValue(interaction, labelStack = [], fallbackValue = interaction.end) {
    if (interaction.type === 'press') return fallbackValue;
    return $1ce9cf3f9c71f474$var$getEarliestLegacyStopTime(interaction, labelStack) ?? fallbackValue;
}
function $1ce9cf3f9c71f474$var$getPageVisibilityUpToTTI(interaction) {
    const { start: start } = interaction;
    const bm3EndTimeOrInteractionEndTime = $1ce9cf3f9c71f474$var$getBm3EndTimeOrFallbackValue(interaction);
    return (0, $jJ2Ec.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
}
function $1ce9cf3f9c71f474$var$getVisibilityStateFromPerformance(stop) {
    try {
        const results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        return results.reduce((acc = null, { name: name, startTime: startTime })=>{
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch (e) {
        return null;
    }
}
function $1ce9cf3f9c71f474$var$getMoreAccuratePageVisibilityUpToTTI(interaction) {
    const old = $1ce9cf3f9c71f474$var$getPageVisibilityUpToTTI(interaction);
    const tti = $1ce9cf3f9c71f474$var$getEarliestLegacyStopTime(interaction, []);
    if (!tti) return old;
    const buffered = $1ce9cf3f9c71f474$var$getVisibilityStateFromPerformance(tti);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
function $1ce9cf3f9c71f474$var$getMoreAccuratePageVisibilityUpToTTAI(interaction) {
    const old = (0, $3uEtK.default)(interaction);
    const buffered = $1ce9cf3f9c71f474$var$getVisibilityStateFromPerformance(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
function $1ce9cf3f9c71f474$var$getResourceTimings(start, end) {
    return $cSrwI.getResourceTimings(start, end) ?? undefined;
}
function $1ce9cf3f9c71f474$var$getBundleEvalTimings(start) {
    return $33a21.getBundleEvalTimings(start);
}
function $1ce9cf3f9c71f474$var$getSSRSuccess(type) {
    return type === 'page_load' ? $hPcrh.getSSRSuccess() : undefined;
}
function $1ce9cf3f9c71f474$var$getSSRFeatureFlags(type) {
    return type === 'page_load' ? $hPcrh.getSSRFeatureFlags() : undefined;
}
const $1ce9cf3f9c71f474$var$getLCP = (end)=>{
    return new Promise((resolve)=>{
        let observer;
        const timeout = setTimeout(()=>{
            observer?.disconnect();
            resolve(null);
        }, 200);
        const performanceObserverCallback = (list)=>{
            const entries = Array.from(list.getEntries());
            const lastEntry = entries.reduce((agg, entry)=>{
                // Use the latest LCP candidate before TTAI
                if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) return entry;
                return agg;
            }, null);
            clearTimeout(timeout);
            if (!lastEntry || lastEntry === null) resolve(null);
            else resolve(lastEntry.startTime);
        };
        observer = new PerformanceObserver(performanceObserverCallback);
        observer.observe({
            type: 'largest-contentful-paint',
            buffered: true
        });
    });
};
async function $1ce9cf3f9c71f474$var$getPaintMetrics(type, end) {
    if (type !== 'page_load') return {};
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    const lcp = await $1ce9cf3f9c71f474$var$getLCP(end);
    if (lcp) metrics['metric:lcp'] = Math.round(lcp);
    return metrics;
}
function $1ce9cf3f9c71f474$var$getTTAI(interaction) {
    const { start: start, end: end } = interaction;
    const pageVisibilityUpToTTAI = (0, $3uEtK.default)(interaction);
    return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
}
function $1ce9cf3f9c71f474$var$getNavigationMetrics(type) {
    if (type !== 'page_load') return {};
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return {};
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart),
        nextHopProtocol: navigation.nextHopProtocol
    };
    return {
        'metrics:navigation': metrics
    };
}
function $1ce9cf3f9c71f474$var$getPPSMetrics(interaction) {
    const { start: start, end: end } = interaction;
    const config = (0, $53d5Q.getConfig)();
    const interactionStatus = (0, $gY4WW.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $3uEtK.default)(interaction);
    const tti = interaction.apdex?.[0]?.stopTime;
    const ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
    const PPSMetricsAtTTI = tti !== undefined ? (0, $baiQV.getLighthouseMetrics)({
        start: start,
        stop: tti
    }) : null;
    const PPSMetricsAtTTAI = ttai !== undefined ? (0, $baiQV.getLighthouseMetrics)({
        start: start,
        stop: interaction.end
    }) : null;
    if (config?.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
    if (PPSMetricsAtTTI !== null) return {
        ...PPSMetricsAtTTI,
        'metrics@ttai': PPSMetricsAtTTAI
    };
    return {};
}
function $1ce9cf3f9c71f474$var$getSSRProperties(type) {
    return {
        'ssr:success': $1ce9cf3f9c71f474$var$getSSRSuccess(type),
        'ssr:featureFlags': $1ce9cf3f9c71f474$var$getSSRFeatureFlags(type)
    };
}
function $1ce9cf3f9c71f474$var$getAssetsMetrics(interaction, SSRDoneTime) {
    try {
        const config = (0, $53d5Q.getConfig)();
        const { type: type } = interaction;
        const allowedTypes = [
            'page_load'
        ];
        const assetsConfig = config?.assetsConfig;
        if (!allowedTypes.includes(type) || !assetsConfig) // Skip if: type not allowed or assetsClassification isn't configured
        return {};
        const reporter = new (0, $bKXRh.CHRReporter)();
        const resourceTimings = (0, $hS38r.filterResourceTimings)(interaction.start, interaction.end);
        const assets = reporter.get(resourceTimings, assetsConfig, SSRDoneTime);
        if (assets) // Only add assets in case it exists
        return {
            'event:assets': assets
        };
        return {};
    } catch (error) {
        // Skip CHR in case of error
        return {};
    }
}
function $1ce9cf3f9c71f474$var$getBrowserMetadata() {
    const data = {};
    const now = new Date();
    data['event:localHour'] = now.getHours(); // returns the hours for this date according to local time
    data['event:localDayOfWeek'] = now.getDay(); // Sunday - Saturday : 0 - 6
    data['event:localTimezoneOffset'] = now.getTimezoneOffset(); // A number representing the difference, in minutes, between the date as evaluated in the UTC time zone and as evaluated in the local time zone.
    if (navigator.userAgent != null) {
        const browser = (0, (/*@__PURE__*/$parcel$interopDefault($cDast))).getParser(navigator.userAgent);
        data['event:browser:name'] = browser.getBrowserName();
        data['event:browser:version'] = browser.getBrowserVersion();
    }
    if (navigator.hardwareConcurrency != null) data['event:cpus'] = navigator.hardwareConcurrency;
    if (navigator.deviceMemory != null) data['event:memory'] = navigator.deviceMemory;
    // eslint-disable-next-line compat/compat
    if (navigator.connection != null) {
        data['event:network:effectiveType'] = navigator.connection.effectiveType;
        data['event:network:rtt'] = navigator.connection.rtt;
        data['event:network:downlink'] = navigator.connection.downlink;
    }
    return data;
}
function $1ce9cf3f9c71f474$var$getTracingContextData(interaction) {
    const { trace: trace, start: start } = interaction;
    let tracingContextData = {};
    if (trace) tracingContextData = {
        'ufo:tracingContext': {
            'X-B3-TraceId': trace.traceId,
            'X-B3-SpanId': trace.spanId,
            // eslint-disable-next-line compat/compat
            browserTimeOrigin: +(performance.timeOrigin + start).toFixed(2)
        }
    };
    return tracingContextData;
}
function $1ce9cf3f9c71f474$var$optimizeCustomData(interaction) {
    const { customData: customData, legacyMetrics: legacyMetrics } = interaction;
    const customDataMap = customData.reduce((result, { labelStack: labelStack, data: data })=>{
        const label = (0, $3AFGg.stringifyLabelStackFully)(labelStack);
        const value = result.get(label)?.data ?? {};
        result.set(label, {
            labelStack: (0, $3AFGg.optimizeLabelStack)(labelStack, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            data: Object.assign(value, data)
        });
        return result;
    }, new Map());
    if (legacyMetrics) {
        const legacyMetricsFiltered = legacyMetrics.filter((item)=>item.type === 'PAGE_LOAD').reduce((result, currentValue)=>{
            for (const [key, value] of Object.entries(currentValue.custom || {})){
                const label = (0, $3AFGg.stringifyLabelStackFully)([]);
                const labelValue = result.get(label)?.data ?? {};
                result.set(label, {
                    labelStack: (0, $3AFGg.optimizeLabelStack)([], (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    data: Object.assign(labelValue, {
                        [key]: value
                    })
                });
            }
            return result;
        }, new Map());
        return [
            ...customDataMap.values(),
            ...legacyMetricsFiltered.values()
        ];
    }
    return [
        ...customDataMap.values()
    ];
}
function $1ce9cf3f9c71f474$var$optimizeReactProfilerTimings(reactProfilerTimings, interactionStart, reactUFOVersion) {
    const reactProfilerTimingsMap = reactProfilerTimings.reduce((result, { labelStack: labelStack, startTime: startTime, commitTime: commitTime, actualDuration: actualDuration, type: type })=>{
        if (labelStack && startTime >= interactionStart) {
            const label = (0, $3AFGg.stringifyLabelStackFully)(labelStack);
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            const timing = result.get(label) || {
                labelStack: (0, $3AFGg.optimizeLabelStack)(labelStack, reactUFOVersion),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...reactProfilerTimingsMap.values()
    ];
}
function $1ce9cf3f9c71f474$var$optimizeRedirects(redirects, interactionStart) {
    let lastRedirectTime = interactionStart;
    const updatedRedirects = redirects.sort((a, b)=>a.time - b.time).reduce((result, redirect)=>{
        const { fromInteractionName: fromInteractionName, time: time } = redirect;
        if (lastRedirectTime >= interactionStart) result.push({
            labelStack: [
                {
                    n: fromInteractionName
                }
            ],
            startTime: Math.round(lastRedirectTime),
            endTime: Math.round(time)
        });
        lastRedirectTime = time;
        return result;
    }, []);
    return updatedRedirects;
}
function $1ce9cf3f9c71f474$var$optimizeHoldInfo(holdInfo, interactionStart, reactUFOVersion) {
    const holdInfoMap = holdInfo.reduce((result, hold)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, ignoreOnSubmit: ignoreOnSubmit } = hold;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            const label = (0, $3AFGg.stringifyLabelStackFully)([
                ...labelStack,
                {
                    name: name
                }
            ]);
            const startTime = Math.round(start);
            const endTime = Math.round(end);
            const timing = result.get(label) || {
                labelStack: (0, $3AFGg.optimizeLabelStack)([
                    ...labelStack,
                    {
                        name: name
                    }
                ], reactUFOVersion),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return [
        ...holdInfoMap.values()
    ];
}
function $1ce9cf3f9c71f474$var$optimizeSpans(spans, interactionStart, reactUFOVersion) {
    const updatedSpans = spans.reduce((result, span)=>{
        const { labelStack: labelStack, type: type, name: name, start: start, end: end } = span;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: (0, $3AFGg.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}
function $1ce9cf3f9c71f474$var$optimizeRequestInfo(requestInfo, interactionStart, reactUFOVersion) {
    const updatedRequestInfo = requestInfo.reduce((result, reqInfo)=>{
        const { labelStack: labelStack, name: name, start: start, end: end, networkStart: networkStart, networkComplete: networkComplete } = reqInfo;
        const startTime = networkStart ?? start;
        const endTime = networkComplete ?? end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: (0, $3AFGg.optimizeLabelStack)([
                ...labelStack,
                {
                    name: name
                }
            ], reactUFOVersion),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}
function $1ce9cf3f9c71f474$var$optimizeCustomTimings(customTimings, interactionStart) {
    return customTimings.reduce((result, item)=>{
        Object.keys(item.data).forEach((key)=>{
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
}
function $1ce9cf3f9c71f474$var$optimizeMarks(marks, reactUFOVersion) {
    return marks.map(({ labelStack: labelStack, time: time, ...others })=>({
            ...others,
            labelStack: labelStack && (0, $3AFGg.optimizeLabelStack)(labelStack, reactUFOVersion),
            time: Math.round(time)
        }));
}
function $1ce9cf3f9c71f474$var$optimizeApdex(apdex, reactUFOVersion) {
    return apdex.map(({ stopTime: stopTime, labelStack: labelStack, ...others })=>({
            ...others,
            stopTime: Math.round(stopTime),
            ...labelStack ? {
                labelStack: (0, $3AFGg.optimizeLabelStack)(labelStack, reactUFOVersion)
            } : {}
        }));
}
function $1ce9cf3f9c71f474$var$objectToArray(obj = {}) {
    return Object.keys(obj).reduce((result, key)=>{
        result.push({
            label: key,
            data: obj[key]
        });
        return result;
    }, []);
}
function $1ce9cf3f9c71f474$var$getBM3SubmetricsTimings(submetrics) {
    if (!submetrics) return null;
    const submetricsTimings = submetrics.filter((item)=>{
        return typeof item.stop === 'number' && !!item.key && typeof item.start === 'number';
    }).map((item)=>{
        let childSubmetrics;
        const newKey = `include/${item.key}`;
        if (item.submetrics) childSubmetrics = $1ce9cf3f9c71f474$var$getBM3SubmetricsTimings(item.submetrics);
        return {
            [newKey]: {
                endTime: item.stop - item.start,
                startTime: item.start
            },
            ...childSubmetrics ? childSubmetrics : {}
        };
    });
    return submetricsTimings;
}
function $1ce9cf3f9c71f474$var$getBm3TrackerTimings(interaction) {
    const interactionLegacyMetrics = interaction.legacyMetrics;
    if (!interactionLegacyMetrics) return {};
    const legacyMetrics = interactionLegacyMetrics.map((item)=>{
        return {
            key: item.key,
            startTime: item.start,
            stopTime: item.stop,
            type: item.config?.type,
            reactUFOName: item.config?.reactUFOName,
            fmp: item.marks?.['fmp'] || item.stop,
            source: 'bm3',
            timings: (0, $hhnFy.getBm3Timings)(item.marks, item.config.timings),
            submetrics: $1ce9cf3f9c71f474$var$getBM3SubmetricsTimings(item.submetrics),
            pageVisibleState: item.pageVisibleState
        };
    }).filter((item)=>!!item.type);
    return {
        legacyMetrics: legacyMetrics
    };
}
function $1ce9cf3f9c71f474$var$getPayloadSize(payload) {
    return Math.round(new TextEncoder().encode(JSON.stringify(payload)).length / 1024);
}
function $1ce9cf3f9c71f474$var$getStylesheetMetrics() {
    try {
        const stylesheets = Array.from(document.styleSheets);
        const stylesheetCount = stylesheets.length;
        const cssrules = Array.from(document.styleSheets).reduce((acc, item)=>{
            // Other domain stylesheets throw a SecurityError
            try {
                return acc + item.cssRules.length;
            } catch (e) {
                return acc;
            }
        }, 0);
        const styleElements = document.querySelectorAll('style').length;
        const styleProps = document.querySelectorAll('[style]');
        const styleDeclarations = Array.from(document.querySelectorAll('[style]')).reduce((acc, item)=>{
            try {
                if ('style' in item) return acc + item.style.length;
                else return acc;
            } catch (e) {
                return acc;
            }
        }, 0);
        return {
            'ufo:stylesheets': stylesheetCount,
            'ufo:styleElements': styleElements,
            'ufo:styleProps': styleProps.length,
            'ufo:styleDeclarations': styleDeclarations,
            'ufo:cssrules': cssrules
        };
    } catch (e) {
        return {};
    }
}
let $1ce9cf3f9c71f474$var$regularTTAI;
let $1ce9cf3f9c71f474$var$expTTAI;
function $1ce9cf3f9c71f474$var$getErrorCounts(interaction) {
    return {
        'ufo:errors:globalCount': (0, $5QpZa.getGlobalErrorCount)(),
        'ufo:errors:count': interaction.errors.length
    };
}
async function $1ce9cf3f9c71f474$var$createInteractionMetricsPayload(interaction, interactionId, experimental) {
    const interactionPayloadStart = performance.now();
    const config = (0, $53d5Q.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const { end: end, start: start, ufoName: ufoName, knownSegments: knownSegments, rate: rate, type: type, abortReason: abortReason, routeName: routeName, featureFlags: featureFlags, previousInteractionName: previousInteractionName, isPreviousInteractionAborted: isPreviousInteractionAborted, abortedByInteractionName: abortedByInteractionName, responsiveness: responsiveness } = interaction;
    const pageVisibilityAtTTI = $1ce9cf3f9c71f474$var$getPageVisibilityUpToTTI(interaction);
    const pageVisibilityAtTTAI = (0, $3uEtK.default)(interaction);
    const segments = config.killswitchNestedSegments ? [] : knownSegments;
    const segmentTree = (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? (0, $3AFGg.buildSegmentTree)(segments.map((segment)=>segment.labelStack)) : {};
    const isDetailedPayload = pageVisibilityAtTTAI === 'visible';
    const isPageLoad = type === 'page_load';
    const calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
    const moreAccuratePageVisibilityAtTTI = calculatePageVisibilityFromTheStartOfPageLoad ? $1ce9cf3f9c71f474$var$getMoreAccuratePageVisibilityUpToTTI(interaction) : null;
    const moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? $1ce9cf3f9c71f474$var$getMoreAccuratePageVisibilityUpToTTAI(interaction) : null;
    const labelStack = interaction.labelStack ? {
        labelStack: (0, $3AFGg.optimizeLabelStack)(interaction.labelStack, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type))
    } : {};
    // Page Load
    const getInitialPageLoadSSRMetrics = ()=>{
        if (!isPageLoad) return {};
        const config = (0, $53d5Q.getConfig)();
        const SSRDoneTimeValue = (0, $657nk.default)(config);
        const SSRDoneTime = SSRDoneTimeValue !== undefined ? {
            SSRDoneTime: Math.round(SSRDoneTimeValue)
        } : {};
        return {
            ...SSRDoneTime,
            isBM3ConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp,
            isUFOConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!config?.ssr?.getSSRDoneTime
        };
    };
    const pageLoadInteractionMetrics = getInitialPageLoadSSRMetrics();
    // Detailed payload. Page visibility = visible
    const getDetailedInteractionMetrics = (resourceTimings)=>{
        if (experimental || window.__UFO_COMPACT_PAYLOAD__ || !isDetailedPayload) return {};
        const spans = [
            ...interaction.spans,
            ...(0, $4u5NT.interactionSpans)
        ];
        (0, $4u5NT.interactionSpans).length = 0;
        return {
            errors: interaction.errors.map(({ labelStack: labelStack, ...others })=>({
                    ...others,
                    labelStack: labelStack && (0, $3AFGg.optimizeLabelStack)(labelStack, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type))
                })),
            holdActive: [
                ...interaction.holdActive.values()
            ],
            redirects: $1ce9cf3f9c71f474$var$optimizeRedirects(interaction.redirects, start),
            holdInfo: $1ce9cf3f9c71f474$var$optimizeHoldInfo(experimental ? interaction.holdExpInfo : interaction.holdInfo, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            spans: $1ce9cf3f9c71f474$var$optimizeSpans(spans, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            requestInfo: $1ce9cf3f9c71f474$var$optimizeRequestInfo(interaction.requestInfo, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
            customTimings: $1ce9cf3f9c71f474$var$optimizeCustomTimings(interaction.customTimings, start),
            bundleEvalTimings: $1ce9cf3f9c71f474$var$objectToArray($1ce9cf3f9c71f474$var$getBundleEvalTimings(start)),
            resourceTimings: $1ce9cf3f9c71f474$var$objectToArray(resourceTimings)
        };
    };
    // Page load & detailed payload
    const getPageLoadDetailedInteractionMetrics = ()=>{
        if (!isPageLoad || !isDetailedPayload) return {};
        const config = (0, $53d5Q.getConfig)();
        return {
            initialPageLoadExtraTimings: $1ce9cf3f9c71f474$var$objectToArray($5i8ML.getTimings()),
            SSRTimings: config?.ssr?.getSSRTimings ? config.ssr.getSSRTimings() : $1ce9cf3f9c71f474$var$objectToArray($hPcrh.getSSRTimings())
        };
    };
    if (experimental) $1ce9cf3f9c71f474$var$expTTAI = $1ce9cf3f9c71f474$var$getTTAI(interaction);
    else $1ce9cf3f9c71f474$var$regularTTAI = $1ce9cf3f9c71f474$var$getTTAI(interaction);
    const newUFOName = (0, $3AFGg.sanitizeUfoName)(ufoName);
    const resourceTimings = $1ce9cf3f9c71f474$var$getResourceTimings(start, end);
    const [vcMetrics, experimentalMetrics, paintMetrics] = await Promise.all([
        (0, $gffgQ.default)(interaction),
        experimental ? (0, $aqLdL.getExperimentalVCMetrics)(interaction) : Promise.resolve(undefined),
        $1ce9cf3f9c71f474$var$getPaintMetrics(type, end)
    ]);
    const payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:sizeInKb': 0,
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)
                },
                'event:region': config.region || 'unknown',
                'experience:key': experimental ? 'custom.experimental-interaction-metrics' : 'custom.interaction-metrics',
                'experience:name': newUFOName,
                ...(0, $dh538.fg)('platform_ufo_report_cpu_usage') ? {
                    'event:cpu:usage': (0, $i328h.createPressureStateReport)(interaction.start, interaction.end)
                } : {},
                // root
                ...$1ce9cf3f9c71f474$var$getBrowserMetadata(),
                ...$1ce9cf3f9c71f474$var$getSSRProperties(type),
                ...$1ce9cf3f9c71f474$var$getAssetsMetrics(interaction, pageLoadInteractionMetrics?.SSRDoneTime),
                ...$1ce9cf3f9c71f474$var$getPPSMetrics(interaction),
                ...paintMetrics,
                ...$1ce9cf3f9c71f474$var$getNavigationMetrics(type),
                ...vcMetrics,
                ...experimentalMetrics,
                ...config.additionalPayloadData?.(interaction),
                ...$1ce9cf3f9c71f474$var$getTracingContextData(interaction),
                ...$1ce9cf3f9c71f474$var$getStylesheetMetrics(),
                ...$1ce9cf3f9c71f474$var$getErrorCounts(interaction),
                interactionMetrics: {
                    namePrefix: config.namePrefix || '',
                    segmentPrefix: config.segmentPrefix || '',
                    interactionId: interactionId,
                    pageVisibilityAtTTI: pageVisibilityAtTTI,
                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                    experimental__pageVisibilityAtTTI: moreAccuratePageVisibilityAtTTI,
                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                    rate: // raw interaction metrics
                    rate,
                    routeName: routeName,
                    type: type,
                    abortReason: abortReason,
                    featureFlags: featureFlags,
                    previousInteractionName: previousInteractionName,
                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                    abortedByInteractionName: abortedByInteractionName,
                    // performance
                    apdex: $1ce9cf3f9c71f474$var$optimizeApdex(interaction.apdex, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    end: Math.round(end),
                    start: Math.round(start),
                    segments: (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? segmentTree : segments.map(({ labelStack: labelStack, ...others })=>({
                            ...others,
                            labelStack: (0, $3AFGg.optimizeLabelStack)(labelStack, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type))
                        })),
                    marks: $1ce9cf3f9c71f474$var$optimizeMarks(interaction.marks, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    customData: $1ce9cf3f9c71f474$var$optimizeCustomData(interaction),
                    reactProfilerTimings: $1ce9cf3f9c71f474$var$optimizeReactProfilerTimings(interaction.reactProfilerTimings, start, (0, $6Zbgf.getReactUFOPayloadVersion)(interaction.type)),
                    ...responsiveness ? {
                        responsiveness: responsiveness
                    } : {},
                    ...labelStack,
                    ...pageLoadInteractionMetrics,
                    ...getDetailedInteractionMetrics(resourceTimings),
                    ...getPageLoadDetailedInteractionMetrics(),
                    ...$1ce9cf3f9c71f474$var$getBm3TrackerTimings(interaction),
                    'metric:ttai': experimental ? $1ce9cf3f9c71f474$var$regularTTAI || $1ce9cf3f9c71f474$var$expTTAI : undefined,
                    'metric:experimental:ttai': $1ce9cf3f9c71f474$var$expTTAI
                },
                'ufo:payloadTime': (0, $8litl.roundEpsilon)(performance.now() - interactionPayloadStart)
            }
        }
    };
    if (experimental) {
        $1ce9cf3f9c71f474$var$regularTTAI = undefined;
        $1ce9cf3f9c71f474$var$expTTAI = undefined;
    }
    payload.attributes.properties['event:sizeInKb'] = $1ce9cf3f9c71f474$var$getPayloadSize(payload.attributes.properties);
    return payload;
}
async function $1ce9cf3f9c71f474$export$51b606e6d67c2231(interactionId, interaction) {
    const ufoNameOverride = $1ce9cf3f9c71f474$var$getUfoNameOverride(interaction);
    const modifiedInteraction = {
        ...interaction,
        ufoName: ufoNameOverride
    };
    const interactionMetricsPayload = await $1ce9cf3f9c71f474$var$createInteractionMetricsPayload(modifiedInteraction, interactionId);
    return [
        interactionMetricsPayload
    ];
}
async function $1ce9cf3f9c71f474$export$6410c9ddb2ab201(interactionId, interaction) {
    const config = (0, $53d5Q.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    const ufoName = (0, $3AFGg.sanitizeUfoName)(interaction.ufoName);
    const rate = (0, $53d5Q.getExperimentalInteractionRate)(ufoName, interaction.type);
    if (!(0, $1haRI.default)(rate)) return null;
    const pageVisibilityState = (0, $jJ2Ec.getPageVisibilityState)(interaction.start, interaction.end);
    if (pageVisibilityState !== 'visible') return null;
    const result = await $1ce9cf3f9c71f474$var$createInteractionMetricsPayload(interaction, interactionId, true);
    return result;
}

});
parcelRegister("bKXRh", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $f1a4e844f2e94c0f$export$7d0d4cfb6455ffa5);

var $dh538 = parcelRequire("dh538");

var $8bVxN = parcelRequire("8bVxN");
class $f1a4e844f2e94c0f$export$783d6618ee601ba {
    add(asset) {
        const encodedSize = asset.encodedSize || 0;
        const type = (0, $8bVxN.calculateTransferType)(asset.name, asset.initiatorType, asset.duration, asset.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += encodedSize;
        this.sizeTotal += encodedSize;
    }
    static makePayload(summary) {
        const { size: size, bundlesCount: bundlesCount, sizeTotal: sizeTotal } = summary;
        const cachedSize = size[0, $8bVxN.MEMORY_KEY] + size[0, $8bVxN.DISK_KEY];
        const sizeRatio = (0, $8bVxN.round)(cachedSize / summary.sizeTotal);
        return {
            size: sizeTotal,
            chr: sizeRatio,
            count: bundlesCount
        };
    }
    constructor(){
        this.bundles = {
            [(0, $8bVxN.MEMORY_KEY)]: 0,
            [(0, $8bVxN.DISK_KEY)]: 0,
            [(0, $8bVxN.NETWORK_KEY)]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [(0, $8bVxN.MEMORY_KEY)]: 0,
            [(0, $8bVxN.DISK_KEY)]: 0,
            [(0, $8bVxN.NETWORK_KEY)]: 0
        };
        this.sizeTotal = 0;
    }
}
class $f1a4e844f2e94c0f$export$7d0d4cfb6455ffa5 {
    get(resourceTimings, assetsConfig, SSRDoneTime) {
        try {
            if (resourceTimings === null) return null;
            resourceTimings.forEach((entry)=>{
                if (!(0, $8bVxN.checkIfTimingsAvailable)(entry)) return;
                const hasNanValues = (0, $dh538.fg)('platform_ufo_assets_check_for_nan') ? entry.encodedSize === undefined || entry.encodedSize === null : false;
                if (entry.encodedSize === entry.decodedSize || hasNanValues) // incorrectly reported or lack of size
                return;
                const type = (0, $8bVxN.getTypeOfRequest)(entry);
                if (!(assetsConfig.allowedTypes || this.defaultAllowedTypes).includes(type)) return;
                if (assetsConfig.classification.all) this.all.add(entry);
                if (assetsConfig.classification.allAtlassian({
                    entry: entry
                })) this.allAtlassian.add(entry);
                if (assetsConfig.classification.preloaded({
                    entry: entry,
                    SSRDoneTime: SSRDoneTime
                })) this.preloaded.add(entry);
            });
            if (this.all.bundlesCount === 0) return null;
            const CHRData = {
                all: $f1a4e844f2e94c0f$export$783d6618ee601ba.makePayload(this.all),
                allAtlassian: $f1a4e844f2e94c0f$export$783d6618ee601ba.makePayload(this.allAtlassian),
                preloaded: $f1a4e844f2e94c0f$export$783d6618ee601ba.makePayload(this.preloaded)
            };
            return CHRData;
        } catch (error) {
            return null;
        }
    }
    constructor(){
        this.all = new $f1a4e844f2e94c0f$export$783d6618ee601ba();
        this.allAtlassian = new $f1a4e844f2e94c0f$export$783d6618ee601ba();
        this.preloaded = new $f1a4e844f2e94c0f$export$783d6618ee601ba();
        this.defaultAllowedTypes = [
            'js'
        ];
    }
}

});
parcelRegister("8bVxN", function(module, exports) {

$parcel$export(module.exports, "MEMORY_KEY", () => $520a8a2d79af9583$export$22f4983702ea2cc3);
$parcel$export(module.exports, "DISK_KEY", () => $520a8a2d79af9583$export$d85e88075ae28804);
$parcel$export(module.exports, "NETWORK_KEY", () => $520a8a2d79af9583$export$c46019be3f2161d7);
$parcel$export(module.exports, "calculateTransferType", () => $520a8a2d79af9583$export$82deef6698791e4e);
$parcel$export(module.exports, "getTypeOfRequest", () => $520a8a2d79af9583$export$d63396a1f85f70a0);
$parcel$export(module.exports, "checkIfTimingsAvailable", () => $520a8a2d79af9583$export$c67eec4e6ad72694);
$parcel$export(module.exports, "round", () => $520a8a2d79af9583$export$2077e0241d6afd3c);
const $520a8a2d79af9583$export$5e1aa91d6932ddaa = [
    'script',
    'link',
    'other'
];
const $520a8a2d79af9583$export$22f4983702ea2cc3 = 'mem';
const $520a8a2d79af9583$export$d85e88075ae28804 = 'disk';
const $520a8a2d79af9583$export$c46019be3f2161d7 = 'net';
function $520a8a2d79af9583$export$82deef6698791e4e(name, type, duration, size) {
    if (!$520a8a2d79af9583$export$5e1aa91d6932ddaa.includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    if ((size === undefined || size === 0) && duration === 0) return $520a8a2d79af9583$export$22f4983702ea2cc3;
    if (size === 0 && duration > 0) return $520a8a2d79af9583$export$d85e88075ae28804;
    if (size === undefined) return null;
    return $520a8a2d79af9583$export$c46019be3f2161d7;
}
function $520a8a2d79af9583$export$d63396a1f85f70a0({ name: name, initiatorType: type }) {
    let category = 'other';
    const urlWithoutQuery = name.split('?')[0];
    switch(type){
        case 'script':
            category = 'js';
            break;
        case 'link':
            if (urlWithoutQuery.endsWith('.css')) category = 'css';
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            break;
        case 'img':
            category = 'image';
            break;
        case 'font':
            category = 'font';
            break;
        default:
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            else if (urlWithoutQuery.endsWith('.css')) category = 'css';
            else if (urlWithoutQuery.match(/\.(woff|woff2|ttf|otf)$/)) category = 'font';
            else if (urlWithoutQuery.match(/\.(png|jpg|jpeg|gif|svg)$/)) category = 'image';
            break;
    }
    return category;
}
function $520a8a2d79af9583$export$c67eec4e6ad72694(entry) {
    if (entry.decodedSize === 0 && entry.encodedSize === 0 && entry.requestStart === 0 && entry.responseStart === 0) return false;
    return true;
}
function $520a8a2d79af9583$export$2077e0241d6afd3c(n) {
    if (isNaN(n)) return 0;
    return Math.round(n * 10000) / 10000;
}

});


parcelRegister("33a21", function(module, exports) {

$parcel$export(module.exports, "getBundleEvalTimings", () => $82bb365c64d311e4$export$2eda1519e91a4386);

var $8litl = parcelRequire("8litl");
let $82bb365c64d311e4$var$config = null;
function $82bb365c64d311e4$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $82bb365c64d311e4$var$config = bundleEvalTimingConfiguration;
}
function $82bb365c64d311e4$var$getPerformanceObject() {
    return (window ?? {}).performance;
}
function $82bb365c64d311e4$export$2eda1519e91a4386(interactionStartTime) {
    if ($82bb365c64d311e4$var$config == null) return {};
    const started = {};
    const timings = {};
    const cachedConfig = $82bb365c64d311e4$var$config;
    const performance = $82bb365c64d311e4$var$getPerformanceObject();
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $8litl.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $8litl.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("8litl", function(module, exports) {

$parcel$export(module.exports, "roundEpsilon", () => $1eb0154571433801$export$56014375de40214b);
function $1eb0154571433801$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("hhnFy", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $6741ca490e409134$export$f02972da195a43bb);

var $gwFzn = parcelRequire("gwFzn");

var $9x4nt = parcelRequire("9x4nt");

var $feexy = parcelRequire("feexy");

var $4u5NT = parcelRequire("4u5NT");
function $6741ca490e409134$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $6741ca490e409134$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $gwFzn.useContext)((0, $9x4nt.default));
    const interactionId = (0, $feexy.getInteractionId)().current;
    (0, $gwFzn.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $4u5NT.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $6741ca490e409134$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $6741ca490e409134$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $feexy.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $4u5NT.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $6741ca490e409134$export$f02972da195a43bb(marks, timingsConfig);
        (0, $4u5NT.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("5i8ML", function(module, exports) {

$parcel$export(module.exports, "getTimings", () => $e739d2e1bf4e00f5$export$6d488733a547304);
const $e739d2e1bf4e00f5$var$timings = [];
function $e739d2e1bf4e00f5$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
    $e739d2e1bf4e00f5$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $e739d2e1bf4e00f5$export$6d488733a547304() {
    const reportedTimingsObj = {};
    $e739d2e1bf4e00f5$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
        const startEntryList = performance.getEntriesByName(startMark);
        const stopEntryList = performance.getEntriesByName(stopMark);
        if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
            const startEntry = startEntryList[startEntryList.length - 1];
            const stopEntry = stopEntryList[stopEntryList.length - 1];
            const { startTime: startTime } = startEntry;
            const duration = stopEntry.startTime - startTime;
            const timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

});

parcelRegister("cSrwI", function(module, exports) {

$parcel$export(module.exports, "getResourceTimings", () => $f909860e385c37d9$export$9eebb59359c2e9e5);

var $dh538 = parcelRequire("dh538");

var $53d5Q = parcelRequire("53d5Q");

var $8litl = parcelRequire("8litl");

var $aanDq = parcelRequire("aanDq");

var $hS38r = parcelRequire("hS38r");
const $f909860e385c37d9$var$alwaysCacheableTypes = [
    'script',
    'link'
];
const $f909860e385c37d9$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $f909860e385c37d9$var$CACHE_NETWORK = 'network';
const $f909860e385c37d9$var$CACHE_MEMORY = 'memory';
const $f909860e385c37d9$var$CACHE_DISK = 'disk';
function $f909860e385c37d9$var$isCacheableType(url, type) {
    if ($f909860e385c37d9$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $f909860e385c37d9$var$calculateTransferType(name, type, duration, size) {
    if (!$f909860e385c37d9$var$isCacheableType(name, type)) return $f909860e385c37d9$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $f909860e385c37d9$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $f909860e385c37d9$var$CACHE_DISK;
    if (size === undefined) return null;
    return $f909860e385c37d9$var$CACHE_NETWORK;
}
function $f909860e385c37d9$var$getWindowObject() {
    return typeof window !== 'undefined' && !!window ? window : undefined;
}
function $f909860e385c37d9$var$hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
    return !$f909860e385c37d9$var$isCacheableType(url, type) || url.includes('localhost') || !!$f909860e385c37d9$var$getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
}
function $f909860e385c37d9$var$getReportedInitiatorTypes(xhrEnabled) {
    const ufoConfig = (0, $53d5Q.getConfig)();
    if (!ufoConfig?.allowedResources) {
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'other',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch',
            'other'
        ];
    }
    return ufoConfig.allowedResources;
}
function $f909860e385c37d9$var$evaluateAccessToResourceTimings(url, entry) {
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $f909860e385c37d9$var$getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
}
function $f909860e385c37d9$var$getNetworkData(item, eventStart, hasTimingHeaders = $f909860e385c37d9$var$evaluateAccessToResourceTimings) {
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart, requestStart: requestStart, serverTime: serverTime, networkTime: networkTime, encodedSize: encodedSize, decodedSize: decodedSize } = item;
    const ttfb = (0, $8litl.roundEpsilon)(responseStart - eventStart);
    const requestStartRelative = (0, $8litl.roundEpsilon)(requestStart - eventStart);
    if (!$f909860e385c37d9$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($f909860e385c37d9$var$isCacheableType(name, initiatorType)) {
        const transferType = $f909860e385c37d9$var$calculateTransferType(name, initiatorType, duration, transferSize);
        return {
            ttfb: ttfb,
            transferType: transferType,
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: encodedSize,
            decodedSize: decodedSize,
            ...$f909860e385c37d9$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        serverTime: serverTime,
        networkTime: networkTime,
        requestStart: (0, $dh538.fg)('ufo_return_relative_request_start') ? requestStartRelative : requestStart,
        ...$f909860e385c37d9$var$getSizeObject(transferSize)
    };
}
function $f909860e385c37d9$export$9eebb59359c2e9e5(interactionStart, interactionEnd) {
    const resourceTiming = {};
    if (interactionStart === null) return resourceTiming;
    const resources = (0, $hS38r.filterResourceTimings)(interactionStart, interactionEnd);
    if (!resources?.length) return resourceTiming;
    const { xhrFilter: xhrFilter, sanitiseEndpoints: sanitiseEndpoints, mapResources: mapResources, hasTimingHeaders: hasTimingHeaders } = (0, $aanDq.getConfig)();
    const reportedInitiatorTypes = $f909860e385c37d9$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        if (initiatorType === 'other' && !name.includes('.js')) return;
        const url = $f909860e385c37d9$var$resourceTypes.includes(initiatorType) ? sanitiseEndpoints(name) : mapResources(name);
        if (!url) return;
        if (resourceTiming[url]) {
            resourceTiming[url].count = (resourceTiming[url].count || 1) + 1;
            return;
        }
        resourceTiming[url] = {
            startTime: (0, $8litl.roundEpsilon)(startTime - interactionStart),
            duration: (0, $8litl.roundEpsilon)(duration),
            workerStart: Math.max((0, $8litl.roundEpsilon)(workerStart - interactionStart), 0),
            fetchStart: Math.max((0, $8litl.roundEpsilon)(fetchStart - interactionStart), 0),
            type: initiatorType,
            ...$f909860e385c37d9$var$getNetworkData(item, interactionStart, hasTimingHeaders)
        };
    });
    return resourceTiming;
}

});
parcelRegister("aanDq", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $f9a9983405b992e1$export$44487a86467333c3);

var $53d5Q = parcelRequire("53d5Q");
const $f9a9983405b992e1$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $f9a9983405b992e1$var$getAllowedParams() {
    const config = (0, $53d5Q.getConfig)();
    return config?.allowedResourcesParams || $f9a9983405b992e1$var$defaultAllowedParams;
}
function $f9a9983405b992e1$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $f9a9983405b992e1$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch (e) {
        return urlString;
    }
}
let $f9a9983405b992e1$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $f9a9983405b992e1$var$handleQueryParams(url);
    }
};
function $f9a9983405b992e1$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $f9a9983405b992e1$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $f9a9983405b992e1$var$config = newConfig;
}
function $f9a9983405b992e1$export$44487a86467333c3() {
    return $f9a9983405b992e1$var$config;
}

});

parcelRegister("hS38r", function(module, exports) {

$parcel$export(module.exports, "filterResourceTimings", () => $3117d1f5648443d3$export$4138a729ef1db028);

var $8litl = parcelRequire("8litl");
const $3117d1f5648443d3$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $3117d1f5648443d3$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $3117d1f5648443d3$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $8litl.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $8litl.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $8litl.roundEpsilon)(entry.startTime),
            duration: (0, $8litl.roundEpsilon)(entry.duration),
            fetchStart: (0, $8litl.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $8litl.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $8litl.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $8litl.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $8litl.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $8litl.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $3117d1f5648443d3$var$getPerformanceObject();
        const PerformanceObserver = $3117d1f5648443d3$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($3117d1f5648443d3$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $3117d1f5648443d3$export$bea963256235a63e.timings = resources.map((resource)=>$3117d1f5648443d3$export$bea963256235a63e.transformResource(resource));
        $3117d1f5648443d3$export$bea963256235a63e.observer = new PerformanceObserver($3117d1f5648443d3$export$bea963256235a63e.addTimings);
        $3117d1f5648443d3$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($3117d1f5648443d3$export$bea963256235a63e.observer) {
            $3117d1f5648443d3$export$bea963256235a63e.observer.disconnect();
            $3117d1f5648443d3$export$bea963256235a63e.observer = null;
        }
        $3117d1f5648443d3$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$3117d1f5648443d3$export$bea963256235a63e.transformResource(entry));
        const overflow = $3117d1f5648443d3$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $3117d1f5648443d3$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $3117d1f5648443d3$export$bea963256235a63e.maxSize;
            $3117d1f5648443d3$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $3117d1f5648443d3$export$bea963256235a63e.timings.push(...entries);
    }
};
function $3117d1f5648443d3$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $3117d1f5648443d3$export$4138a729ef1db028(startTime, endTime) {
    const performance = $3117d1f5648443d3$var$getPerformanceObject();
    const PerformanceObserver = $3117d1f5648443d3$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$3117d1f5648443d3$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$3117d1f5648443d3$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $3117d1f5648443d3$export$bea963256235a63e.timings.filter((timing)=>$3117d1f5648443d3$var$isValidTiming(timing, startTime, endTime));
}

});


parcelRegister("hPcrh", function(module, exports) {

$parcel$export(module.exports, "configure", () => $9d50b67dcef9fae2$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $9d50b67dcef9fae2$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $9d50b67dcef9fae2$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRDoneTime", () => $9d50b67dcef9fae2$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $9d50b67dcef9fae2$export$1c4a9b5e6e22393d);
const $9d50b67dcef9fae2$var$NESTED_METRIC_SEPARATOR = '/';
function $9d50b67dcef9fae2$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $9d50b67dcef9fae2$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
}
const $9d50b67dcef9fae2$var$SSR_PREFIX = 'ssr';
function $9d50b67dcef9fae2$var$mapKey(key) {
    if (key === 'total') return $9d50b67dcef9fae2$var$SSR_PREFIX;
    return `${$9d50b67dcef9fae2$var$SSR_PREFIX}${$9d50b67dcef9fae2$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $9d50b67dcef9fae2$var$config;
function $9d50b67dcef9fae2$export$8d21e34596265fa2(ssrConfig) {
    $9d50b67dcef9fae2$var$config = ssrConfig;
}
function $9d50b67dcef9fae2$export$bf7408e83532dcd0() {
    if (!$9d50b67dcef9fae2$var$config?.getTimings) return {};
    const timings = $9d50b67dcef9fae2$var$config.getTimings();
    if (!timings) return {};
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($9d50b67dcef9fae2$var$filterEntry(entry[1])) acc[$9d50b67dcef9fae2$var$mapKey(entry[0])] = $9d50b67dcef9fae2$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $9d50b67dcef9fae2$export$c7ad864055e75537() {
    return !!$9d50b67dcef9fae2$var$config?.getDoneMark();
}
function $9d50b67dcef9fae2$export$3def7672244bab0c() {
    return $9d50b67dcef9fae2$var$config?.getDoneMark() ?? undefined;
}
function $9d50b67dcef9fae2$export$1c4a9b5e6e22393d() {
    if (!$9d50b67dcef9fae2$var$config?.getFeatureFlags) return undefined;
    try {
        return $9d50b67dcef9fae2$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return undefined;
}

});

parcelRegister("3AFGg", function(module, exports) {

$parcel$export(module.exports, "sanitizeUfoName", () => $6914878c06e1c53a$export$e08487ea3ae92adb);
$parcel$export(module.exports, "isSegmentLabel", () => $6914878c06e1c53a$export$1adbaf5c2363e4ae);
$parcel$export(module.exports, "buildSegmentTree", () => $6914878c06e1c53a$export$1569bc0edeecbcd8);
$parcel$export(module.exports, "stringifyLabelStackFully", () => $6914878c06e1c53a$export$caeee352b541de1f);
$parcel$export(module.exports, "labelStackStartWith", () => $6914878c06e1c53a$export$1787b1cd413c7e2);
$parcel$export(module.exports, "optimizeLabelStack", () => $6914878c06e1c53a$export$a0cd72da07c76b4c);
function $6914878c06e1c53a$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $6914878c06e1c53a$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $6914878c06e1c53a$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    labelStacks.forEach((labelStack)=>{
        let currentNode = r;
        labelStack.forEach((label)=>{
            const name = label.name;
            const id = $6914878c06e1c53a$export$1adbaf5c2363e4ae(label) ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name
            };
            currentNode = currentNode.c[key];
        });
    });
    return {
        r: r
    };
}
function $6914878c06e1c53a$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        if ($6914878c06e1c53a$export$1adbaf5c2363e4ae(l)) return `${l.name}:${l.segmentId}`;
        return l.name;
    }).join('/');
}
function $6914878c06e1c53a$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$6914878c06e1c53a$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name).join('/');
}
function $6914878c06e1c53a$export$1787b1cd413c7e2(labelStack, startWith) {
    return $6914878c06e1c53a$export$caeee352b541de1f(labelStack).startsWith($6914878c06e1c53a$export$caeee352b541de1f(startWith));
}
function $6914878c06e1c53a$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $6914878c06e1c53a$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: ls.name,
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {}
        }));
}

});

parcelRegister("gY4WW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1435165d93993c3e$export$2e2bcd8739ae039);
function $1435165d93993c3e$var$getInteractionStatus(interaction) {
    let originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    const hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $1435165d93993c3e$export$2e2bcd8739ae039 = $1435165d93993c3e$var$getInteractionStatus;

});

parcelRegister("3uEtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde92bd61e8ffee2$export$2e2bcd8739ae039);

var $jJ2Ec = parcelRequire("jJ2Ec");
function $bde92bd61e8ffee2$var$getPageVisibilityUpToTTAI(interaction) {
    const { start: start, end: end } = interaction;
    return (0, $jJ2Ec.getPageVisibilityState)(start, end);
}
var $bde92bd61e8ffee2$export$2e2bcd8739ae039 = $bde92bd61e8ffee2$var$getPageVisibilityUpToTTAI;

});

parcelRegister("6Zbgf", function(module, exports) {

$parcel$export(module.exports, "getReactUFOPayloadVersion", () => $fd354a7ceaa170ad$export$159168550e7449b8);
function $fd354a7ceaa170ad$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return '2.0.0';
}

});

parcelRegister("657nk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8261301e1ba8a2a$export$2e2bcd8739ae039);

var $hPcrh = parcelRequire("hPcrh");
function $a8261301e1ba8a2a$var$getSSRDoneTimeValue(config) {
    return config?.ssr?.getSSRDoneTime ? config?.ssr?.getSSRDoneTime() : $hPcrh.getSSRDoneTime();
}
var $a8261301e1ba8a2a$export$2e2bcd8739ae039 = $a8261301e1ba8a2a$var$getSSRDoneTimeValue;

});

parcelRegister("gffgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c32879a3fa820297$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $53d5Q = parcelRequire("53d5Q");

var $4u5NT = parcelRequire("4u5NT");

var $2DIgf = parcelRequire("2DIgf");

var $gY4WW = parcelRequire("gY4WW");

var $3uEtK = parcelRequire("3uEtK");

var $657nk = parcelRequire("657nk");
async function $c32879a3fa820297$var$getVCMetrics(interaction) {
    const config = (0, $53d5Q.getConfig)();
    if (!config?.vc?.enabled) return {};
    if (interaction.type !== 'page_load' && interaction.type !== 'transition') return {};
    const interactionStatus = (0, $gY4WW.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $3uEtK.default)(interaction);
    const shouldReportVCMetrics = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible';
    if (!shouldReportVCMetrics && (0, $dh538.fg)('platform_ufo_no_vc_on_aborted')) {
        (0, $2DIgf.getVCObserver)().stop(interaction.ufoName);
        return {};
    }
    const isSSREnabled = config?.ssr || config?.vc.ssrWhitelist?.includes(interaction.ufoName);
    const ssr = interaction.type === 'page_load' && isSSREnabled ? {
        ssr: (0, $657nk.default)(config)
    } : null;
    (0, $4u5NT.postInteractionLog).setVCObserverSSRConfig(ssr);
    const tti = interaction.apdex?.[0]?.stopTime;
    const prefix = 'ufo';
    const result = await (0, $2DIgf.getVCObserver)().getVCResult({
        start: interaction.start,
        stop: interaction.end,
        tti: tti,
        prefix: prefix,
        vc: interaction.vc,
        isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED',
        experienceKey: interaction.ufoName,
        interactionId: interaction.id,
        ...ssr
    });
    if (config.experimentalInteractionMetrics?.enabled) (0, $2DIgf.getVCObserver)().stop(interaction.ufoName);
    (0, $4u5NT.postInteractionLog).setLastInteractionFinishVCResult(result);
    if ((0, $dh538.fg)('platform_ufo_vc_enable_revisions_by_experience')) {
        const mostRecentVCRevision = (0, $53d5Q.getMostRecentVCRevision)(interaction.ufoName);
        const mostRecentVCRevisionPayload = result?.['ufo:vc:rev']?.find(({ revision: revision })=>revision === mostRecentVCRevision);
        if (!shouldReportVCMetrics || !mostRecentVCRevisionPayload?.clean) return result;
        return {
            ...result,
            'metric:vc90': mostRecentVCRevisionPayload['metric:vc90']
        };
    } else if (!(0, $53d5Q.isVCRevisionEnabled)('fy25.01')) {
        const ttvcV2Revision = result?.['ufo:vc:rev']?.find(({ revision: revision })=>revision === 'fy25.02');
        if (!ttvcV2Revision?.clean) return result;
        return {
            ...result,
            'metric:vc90': ttvcV2Revision['metric:vc90']
        };
    } else {
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        if (interactionStatus.originalInteractionStatus !== 'SUCCEEDED' || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:vc90': VC['90']
        };
    }
}
var $c32879a3fa820297$export$2e2bcd8739ae039 = $c32879a3fa820297$var$getVCMetrics;

});



//# sourceMappingURL=create-payload.a0e8ef8e.js.map
